module.exports = __webpack_public_path__ + "static/media/gryphon-house-gym.5b671ef0.jpg";